import le from '../core/le.js';
/**
 * Same as {@link le}.
 */
const atMost = le;
export default atMost;
